import { ClientProfile, CoachProfile } from "@joonapp/web-shared"

export interface CoachingGroup {
  profiles: (CoachProfile | ClientProfile)[]
  date_created: string
  id: number
  type: "coaching" // TODO: Update this in types - GroupType.COACHING
}

export enum CoachingLookupKey {
  TEXT_ONLY = "coaching_text_only_monthly",
  ONE_CALL = "coaching_one_call_monthly",
  STANDARD = "coaching_standard_monthly",
  THREE_CALLS = "coaching_three_call_monthly",
  FOUR_CALLS = "coaching_four_call_monthly",
  COACHING_DEV = "coaching_dev",
}

export enum CoachingStep {
  POST_ANSWER_SCREEN = -1,
  LANDING,
  INTAKE_FORM,
  MATCHING,
  COACH_SUMMARY,
  RECOMMENDED_COACHES,
  POST_SELECTION,
  PLAN_SELECT,
  SCHEDULED,
}

// in order of priority
export enum MeTabCardType {
  UNREAD_MESSAGE = "unread_message",
  BOOK_SESSION = "book_session",
  VIEW_NEW_ROUTINE = "view_new_routine",
  SESSION_BOOKED = "session_booked",
  MESSAGE = "message",
}
